import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ThemePicker from './ThemePicker';
import { deleteCookie, getCookie, setCookie } from 'stash/utils/cookies';
import { logOutDev } from 'stash/actions/session';
import { Dialog, Link } from '@stashinvest/ui';
import { getLocalStorage } from '../../../utils/storage.js';

import { dismiss } from 'stash/utils/bridgeMessages';
import { DismissPayloadType } from 'stash/constants/bridgeMessageTypes';
import { sendMessage } from 'stash/utils/native-bridge';
import { isNativeWebview } from 'stash/utils';

const DevToolbar = styled.div`
	position: fixed;
	font-size: 0.7rem;
	top: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.25);
	color: #fff;
	padding: 0.25em;
	z-index: 1000;
	opacity: 0.25;
	transition: opacity 0.3s;

	&:hover {
		opacity: 1;
	}
`;

const DevToolbarItem = styled.span`
	cursor: pointer;

	&:not(:last-child)::after {
		content: ' | ';
	}
`;

const SHOW_DEVTOOLS_IN_ENVIRONMENT = {
	__STASH_ENV__: true,
	review: true,
	local: true,
	edge: true,
	staging: true,
	production: false, // Do NOT set this to true
};

const FEATURES_ENABLED = {
	signupDevTools: {
		__STASH_ENV__: true,
		local: true,
		edge: true,
	},
};

export const mapStateToProps = (state) => ({
	isLoggedIn: !!state.entities.api_key.uuid,
});

export const mapDispatchToProps = {
	logOutDev,
};

class DevTools extends React.Component {
	constructor(props) {
		super(props);
		this.toggleEventLogger = this.toggleEventLogger.bind(this);
		this.hideDevTools = this.hideDevTools.bind(this);
		this.renderThemePickerItem = this.renderThemePickerItem.bind(this);
		this.renderEventLoggerItem = this.renderEventLoggerItem.bind(this);
		this.renderLogOut = this.renderLogOut.bind(this);
		this.renderDevTools = this.renderDevTools.bind(this);
		this.onLogoutClick = this.onLogoutClick.bind(this);

		this.state = {
			showThemePickerDialog: false,
			stashEventLoggerEnabled: getCookie('stashEventLogger') || false,
			stashAPI: (localStorage && getLocalStorage('stashAPI')) || '',
			hidden: false,
		};
	}

	toggleEventLogger() {
		if (this.state.stashEventLoggerEnabled) {
			deleteCookie('stashEventLogger');
			this.setState({ stashEventLoggerEnabled: false });
		} else {
			setCookie('stashEventLogger', true);
			this.setState({ stashEventLoggerEnabled: true });
		}
	}

	hideDevTools(value) {
		this.setState({ hidden: value });
	}

	renderThemePickerItem() {
		const isFeatureOn = FEATURES_ENABLED.signupDevTools[window.Stash.env];

		return (
			isFeatureOn && (
				<DevToolbarItem onClick={() => this.setState({ showThemePickerDialog: true })}>
					<span role="img" aria-label="flag">
						🎨
					</span>
					Theme
				</DevToolbarItem>
			)
		);
	}

	renderSignUpDev() {
		const isFeatureOn = FEATURES_ENABLED.signupDevTools[window.Stash.env];

		return (
			isFeatureOn && (
				<DevToolbarItem>
					<Link href="/dev/sign-up" color="#fff">
						Sign Up
					</Link>
				</DevToolbarItem>
			)
		);
	}

	renderEventLoggerItem() {
		const enabled = this.state.stashEventLoggerEnabled ? 'On' : 'Off';

		return (
			<DevToolbarItem onClick={this.toggleEventLogger}>
				Event Logger {enabled}
			</DevToolbarItem>
		);
	}

	onLogoutClick() {
		if (isNativeWebview()) {
			sendMessage(dismiss(DismissPayloadType.LOGOUT));
		} else {
			this.props.logOutDev();
		}
	}

	renderLogOut() {
		if (!this.props.isLoggedIn) {
			return null;
		}

		return <DevToolbarItem onClick={this.onLogoutClick}>Log out</DevToolbarItem>;
	}

	renderThemePickerDialog() {
		const closeDialog = () => {
			this.setState({
				showThemePickerDialog: false,
			});
		};

		return (
			<Dialog
				open={this.state.showThemePickerDialog}
				cancel={closeDialog}
				confirmText="Activate"
				hideConfirmButton
				isClickableOutside={true}
				shouldRenderHelpLink={false}
				prompt={
					<ThemePicker
						onClickPrimaryButton={closeDialog}
						onClickSecondaryButton={closeDialog}
					/>
				}
				width="40rem"
			/>
		);
	}

	renderDevTools() {
		return (
			<DevToolbar>
				<DevToolbarItem>{window.Stash.version}</DevToolbarItem>
				{this.renderSignUpDev()}
				{this.renderEventLoggerItem()}
				{this.renderThemePickerItem()}
				{this.renderLogOut()}
				<DevToolbarItem onClick={() => this.hideDevTools(true)}>X</DevToolbarItem>
				{this.state.showThemePickerDialog && this.renderThemePickerDialog()}
			</DevToolbar>
		);
	}

	render() {
		return SHOW_DEVTOOLS_IN_ENVIRONMENT[window.Stash.env] && !this.state.hidden
			? this.renderDevTools()
			: null;
	}
}

DevTools.propTypes = {
	isLoggedIn: PropTypes.bool,
	logOutDev: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(DevTools);
